export default {
    id: 3,
    mediaFormIsExperienceDisabled: (mediaFullForm) => mediaFullForm.experience_required === 'no',
    mediaFormUpdated: (newValues, mediaFormThis) => {
        if (newValues.experience_required === 'no') mediaFormThis.mediaFullForm.experience = '0';
    },
    getFormTypeInputFields: () => [
        {
            name: 'experience_required',
            options: 'yes-no',
            validation: {
                required: 'License Type field is required'
            },
        },
        'experienceFields',
        {
            name: 'basic_tools',
            options: 'yes-no',
            validation: {
                required: 'Basic Tools field is required',
            },
            show: (fields) => (fields.basic_tools || '').toLowerCase() === 'yes'
        }
    ],
}
